/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles } from "@material-ui/core/";
import moment from "moment";
import React, { useContext, useState, useEffect } from "react";
import { config as url } from "../../common/config";
import FetchDataContext from "../../context/fetchData/fetchDataContext";
import OptionHandle from "./OptionHandle";
import TableOnReport from "./TableOnReport";

const useStyles = makeStyles((theme) => ({
	root: {
		paddingLeft: "2rem",
		paddingRight: "2rem",
		[theme.breakpoints.down("sm")]: {
			paddingLeft: "1rem",
			paddingRight: "1rem",
		},
	},
}));

const Reports = () => {
	const classes = useStyles();
	const BaseUrl = `${url.report}`;
	const fetchData = useContext(FetchDataContext);
	const {
		getDataTables,
		refreshData,
		tableRef,
		SingleHandleOptions,
		MultiHandleOptionsTask,
		stateOption,
		singleOption,
	} = fetchData;

	const [state] = useState({
		pageSize: 10,
	});
	const [optionChange, setOptionChange] = useState({
		tgl_awal: moment().startOf("month").format("YYYY-MM-DD"),
		tgl_akhir: moment().format("YYYY-MM-DD"),
		idlayanan: 0,
		idstatus: 0,
		idkategori: 0,
		idpriority: 0,
		time: 0,
	});

	useEffect(() => {
		SingleHandleOptions({
			path: "priority",
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [optionChange.idpriority]);

	return (
		<Grid direction="column" alignItems="center" className={classes.root}>
			<OptionHandle
				stateOption={stateOption && stateOption}
				state={optionChange}
				setState={setOptionChange}
				handleSearch={refreshData}
				SingleHandleOptions={SingleHandleOptions}
				singleOption={singleOption}
				MultiHandleOptionsTask={MultiHandleOptionsTask}
			/>
			<TableOnReport
				getDataTables={getDataTables}
				BaseUrl={BaseUrl}
				pageSize={state.pageSize}
				tableRef={tableRef}
				state={optionChange}
			/>
		</Grid>
	);
};
export default Reports;
